import { render, staticRenderFns } from "./NoPageFound.vue?vue&type=template&id=59e58e49&scoped=true&"
import script from "./NoPageFound.vue?vue&type=script&lang=js&"
export * from "./NoPageFound.vue?vue&type=script&lang=js&"
import style0 from "./NoPageFound.vue?vue&type=style&index=0&id=59e58e49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e58e49",
  null
  
)

export default component.exports